module.exports = __webpack_public_path__ + "img/blurmap-PROG-STANDARD_full_white.1318ec96.png";